import template from './csa-stock-info-dialog.html';
export var CSAStockInfoDialogComponent = {
    template: template,
    bindings: {
        itemId: '@',
        warehouseKey: '<',
        stock: '@'
    },
    controller: /** @class */ (function () {
        function CSAStockInfoDialogComponent($mdDialog, CSAService, warehouseService) {
            'ngInject';
            this.error = false;
            this.loading = null;
            this.inventoryLots = null;
            this.$mdDialog = $mdDialog;
            this.CSAService = CSAService;
            this.WarehouseService = warehouseService;
        }
        CSAStockInfoDialogComponent.prototype.$onInit = function () {
            this.getInventoryDetail();
        };
        CSAStockInfoDialogComponent.prototype.getInventoryDetail = function () {
            var _this = this;
            this.loading = this.CSAService.getInventoryDetail(this.warehouseKey, this.itemId)
                .then(function (data) {
                _this.inventoryLots = data.response;
                _this.setWarehouseCode();
            })
                .catch(function () {
                _this.error = true;
            })
                .finally(function () {
                _this.loading = null;
            });
        };
        CSAStockInfoDialogComponent.prototype.onClose = function () {
            this.$mdDialog.hide();
        };
        CSAStockInfoDialogComponent.prototype.setWarehouseCode = function () {
            var _this = this;
            this.WarehouseService.getAllWarehouses().then(function (warehouses) {
                _this.warehouseCode = warehouses.find(function (warehouse) { return warehouse.id == _this.warehouseKey; }).warehouseCode;
            });
        };
        return CSAStockInfoDialogComponent;
    }())
};
//# sourceMappingURL=csa-stock-info-dialog.component.js.map